import {useQuery} from '@tanstack/react-query';
import {fetchReportFile} from '../services/ReportFileService';

export const useReportFile = (fileId?: string) => {

    const reportFileQuery = useQuery({
        queryKey: ['reportFile', fileId],
        queryFn: () => fetchReportFile(fileId!),
        enabled: !!fileId,
    });

    return {
        reportFile: reportFileQuery.data,
        loading: reportFileQuery.isLoading,
    };
};
